import Api from 'src/api/Base'

class GetExportSpaceAllocation extends Api {
  requestUrl = `/api/Export/SpaceAllocation?startDate=${this.getParams().startDate}&endDate=${
    this.getParams().endDate
  }`
}

export default GetExportSpaceAllocation
